const PhoneCall01 = ({ size, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "17"}
      height={size || "17"}
      viewBox="0 0 17 17"
      fill="none"
    >
      <g id="phone-call-01">
        <g id="Solid">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.09519 4.25553C9.1657 3.89416 9.51581 3.65836 9.87719 3.72887C10.6586 3.88132 11.3767 4.26347 11.9396 4.82642C12.5026 5.38936 12.8847 6.10748 13.0372 6.88887C13.1077 7.25024 12.8719 7.60035 12.5105 7.67086C12.1491 7.74137 11.799 7.50557 11.7285 7.14419C11.6269 6.62327 11.3721 6.14452 10.9968 5.76923C10.6215 5.39393 10.1428 5.13916 9.62186 5.03753C9.26049 4.96702 9.02469 4.61691 9.09519 4.25553Z"
            fill={color || "#1570EF"}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.08693 1.64292C9.12759 1.27698 9.45719 1.01329 9.82313 1.05394C11.3263 1.22093 12.728 1.89407 13.7981 2.96283C14.8682 4.0316 15.5431 5.43247 15.712 6.93542C15.7531 7.30131 15.4899 7.63125 15.124 7.67236C14.7581 7.71347 14.4281 7.45019 14.387 7.08431C14.2519 5.88194 13.712 4.76125 12.8559 3.90624C11.9998 3.05122 10.8785 2.51271 9.67592 2.37912C9.30998 2.33847 9.04628 2.00886 9.08693 1.64292Z"
            fill={color || "#1570EF"}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.60812 12.218C2.98551 10.5954 1.80563 8.57472 1.17857 6.36856C1.08024 6.02255 1.00398 5.75424 1.00288 5.38631C1.00163 4.9658 1.13864 4.43897 1.34459 4.07234C1.69878 3.44183 2.45929 2.63379 3.11617 2.30154C3.68373 2.01447 4.354 2.01447 4.92156 2.30154C5.47866 2.58332 6.1177 3.23559 6.45698 3.75742C6.88798 4.42032 6.88798 5.2749 6.45698 5.93779C6.34149 6.11542 6.17687 6.27976 5.98576 6.47054C5.92626 6.52995 5.86076 6.57288 5.90425 6.66347C6.33614 7.56299 6.92513 8.40672 7.67225 9.15384C8.41937 9.90096 9.2631 10.49 10.1626 10.9218C10.2557 10.9665 10.2939 10.9021 10.3555 10.8403C10.5463 10.6492 10.7107 10.4846 10.8883 10.3691C11.5512 9.93811 12.4058 9.93811 13.0687 10.3691C13.5905 10.7084 14.2428 11.3474 14.5245 11.9045C14.8116 12.4721 14.8116 13.1424 14.5245 13.7099C14.1948 14.3619 13.3933 15.1222 12.7537 15.4815C12.3871 15.6875 11.8603 15.8245 11.4398 15.8232C11.0718 15.8221 10.8035 15.7459 10.4575 15.6475C8.25138 15.0205 6.23071 13.8406 4.60812 12.218Z"
            fill={color || "#1570EF"}
          />
        </g>
      </g>
    </svg>
  );
};

export default PhoneCall01;
